if($('header#header').length){
    $('footer#footer .added_info').clone().insertAfter('.top-nav .project-phone'); 
    $('footer#footer .added_socials').clone().insertBefore('.subnav-right'); 
    $('footer#footer .added_info').clone().insertAfter('.navigation-in .menu-level-1'); 
    $('footer#footer .added_mobile_info > a').clone().prependTo('.nav-list.navigation-buttons'); 
    $('.top-nav-currency').clone().insertBefore('.subnav-right .nav-list a[data-target="cart"]')
    $('.top-nav .project-phone').html('<div class="videohovor"><a href="'+videoConzultationLint+'"><i class="fas fa-video"></i> '+videoConzultation+'</a></div>');
    $(window).ready(function() {
        var width = $(window).width();
        if (width  < 570){
      $('.nav-list.top-nav-bar').insertBefore('#navigation .contact-wrap');
      }
      });
      $('header#header div').removeClass('container');
$('.top-nav').wrapInner('<div class="container"></div>');
$('nav#navigation').wrap('<div class="container"></div>');
}